import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';

const _serviceDependencies = ['$scope', '$window', 'Auth', 'Util', '$rootScope', 'Sso'];

/**
 * @ngdoc service
 * @name controllers.Forgot
 *
 * @description
 * Forgot password controller
 */
class Forgot {

    /**
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} $rootScope
     * @param  {any} Sso
     */
    constructor($scope, $window, Auth, Util, $rootScope, Sso) {

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.Auth.loading = false;
        this.Auth.error = false;
        this.Recaptcha = Recaptcha;
        this.Sso = Sso;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.captchaRequired = false;
        this.$scope.submitted = false;

        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();

        }

        // prefill email address if we receive an email param
        // this param should be base64 encoded
        this.$scope.email = this.isBase64();

        if (this.$rootScope.forgotEmail) {

            this.$scope.email = this.$rootScope.forgotEmail;
            delete this.$rootScope.forgotEmail;

        }

        Mixpanel.send('ConnectWeb Auth Forgot Open', {
            Source: 'Direct',
        });

    }

    isBase64() {

        try {

            return this.Sso.getDecodedEmailAddress();

        } catch (err) {

            return '';

        }

    }

    // SSO skip the login and redirect to skip_uri received in params
    skip() {

        Mixpanel.send('ConnectWeb Skip Click', {
            Page: 'Auth Login',
        });

        this.$window.location = this.$scope.skipUri;

    }

    forgotPassword() {

        const forgotPasswordPayload = {
            data: {
                attributes: {
                    email: this.$scope.email,
                },
                type: 'passwords',
                relationships: {
                    partner: {
                        data: {
                            type: 'partners',
                            id: this.$window.appName,
                        },
                    },
                },
            },
            meta: {
                language: CWCONFIG.language,
            },
        };

        const token = this.Util.getToken();

        const headers = {
            Authorization: (token) ?
                `Bearer ${token}` :
                `Basic ${this.Util.base64encode(CWCONFIG.oauthKey)}`,
        };

        const captchaRespose = this.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        this.$scope.submitted = true;

        Mixpanel.send('ConnectWeb Forgot Password Click', {
            Page: 'Auth Forgot',
        });

        if (this.$scope.forgotPasswordForm.$valid) {

            this.Auth.loading = true;
            this.Auth.forgotPassword(forgotPasswordPayload, headers);

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

    onSubmit() {

        if (this.$window.grecaptcha) {

            this.Recaptcha.execute();

        } else {

            this.forgotPassword();

        }

    }

    setCaptchaResponse(response) {

        this.Recaptcha.setCaptchaResponse(response);
        this.forgotPassword();

    }

}


_serviceDependencies.push(Forgot);

angular.module('controllers')
    .controller('Forgot', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/forgot/forgot.js